import React, { useState, useCallback } from 'react'
import { useRouter } from 'next/router'
import { ImCheckmark } from 'react-icons/im'
import Loader from 'react-loader-spinner'
import { ErrorBox, Text, Button } from '@/components/common'
import SegmentHandler from '@/services/analytics/SegmentHandler'
import { emailLogin, register } from '@/services/api/auth'
import useAuth from '@/services/hooks/useAuth'
import { resolveErrorMessage } from '@/utils'
import tailwind from '../../../tailwind.config'
import AuthInput from './AuthInput'

export const VerifyCodeForm = ({ email, password }) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [verified, setVerified] = useState(false)
  const [verificationCode, setVerificationCode] = useState('')
  const { persistUser, closeModal, redirect } = useAuth()
  const router = useRouter()

  const verifyAccount = useCallback(
    async (e) => {
      e.preventDefault()
      setError('')
      setLoading(true)

      try {
        await register(email, password, verificationCode)
        SegmentHandler.track('Auth Completed', {
          location: router.asPath,
          value: 'verifyEmail',
        })

        const res = await emailLogin(password, email)
        setVerified(true)
        persistUser(res.uuid, res.authorization, null, redirect)
        setTimeout(() => closeModal(), 1000)
      } catch (err) {
        setError(resolveErrorMessage(err))
      } finally {
        setLoading(false)
      }
    },
    [
      email,
      password,
      verificationCode,
      router.asPath,
      persistUser,
      closeModal,
      redirect,
    ]
  )

  return (
    <form className="flex flex-col items-center" onSubmit={verifyAccount}>
      <ErrorBox errorText={error} className="mb-4" />
      <Text as="p" preset="body.md" className="mb-2 mt-0 text-center">
        Please enter the 6 digit code
        <br /> we sent to {email}.
      </Text>
      <Text as="p" preset="body.xs" className="mb-2 mt-0 text-center">
        Not seeing it? Check your spam folder.
      </Text>

      <AuthInput
        name="code"
        type="text"
        placeholder="CODE"
        className="w-4/5 text-center"
        textSizeClassName="text-lg"
        onChange={(e) => setVerificationCode(e.target.value)}
        maxLength={6}
      />

      <Button
        className="mt-4 flex w-4/5 items-center justify-center rounded-full"
        type="submit"
        disabled={verificationCode.length !== 6 || loading || verified}
      >
        {loading && (
          <Loader
            type="TailSpin"
            color={tailwind.theme.colors.lightGray}
            className="mr-2"
            height={25}
            width={25}
          />
        )}
        {verified && <ImCheckmark className="mr-3" />}
        <span>Verify Account</span>
      </Button>
    </form>
  )
}

export default VerifyCodeForm
